import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { CustomerProfile } from '../../../models/customerProfile';
import { ConfigService } from '../../config.service';
import { DataStorageService } from '../../data-storage.service';
import { SecurityService } from '../../security.service';

@Injectable()
export class ApiCustomerService {

  constructor(private configService: ConfigService,
    private dataStorageService: DataStorageService,
    private securityService: SecurityService,
    private http: HttpClient) {
  }

  getCustomer(offerID: number): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/customer';
    return new Promise<any>((resolve, reject) => {
      this.http.get<CustomerProfile>(url)
        .toPromise()
        .then((response) => {
          this.dataStorageService.currentState.customerProfile = response;
          resolve();
        }).catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.getCustomer(offerID).then(() => resolve()));
          } else {
            alert(error.message);
            reject(error);
          }
        });
    });
  }

  putCustomer(offerID?: number, body?: CustomerProfile): Promise<any> {
    offerID = offerID ? offerID : this.dataStorageService.currentState.offerID;
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/customer';
    body = body ? body : this.dataStorageService.currentState.customerProfile;
    if (this.dataStorageService.currentState.status === 'OPEN') {
      return new Promise<any>((resolve, reject) => {
        this.http.put(url, body)
          .toPromise()
          .then(() => resolve())
          .catch((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.securityService.refreshToken()
                .then(() => this.putCustomer().then(() => resolve()));
            } else {
              if (error.status >= 400 && error.status < 500) {
                alert('ERROR: Please contact with your administrator');
              } else {
                alert('Please check your internet connection');
              }
              reject();
            }
          });
      });
    } else {
      return new Promise<any>((resolve, reject) => {
        alert('You can not modify WON/LOST offer');
        reject();
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/apiServices/customer/api-customer.service.ts